<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading>
      <capra-icon class="dbt-icon" icon="illo-mini-dbt"></capra-icon>
      {{ currentStep === 1 ? 'Select a metric to use' : 'Choose how to visualize your metric' }}
      <capra-badge class="experimental-badge" text="EXPERIMENTAL" type="green"></capra-badge>
    </h1>
  </mode-dialog-header>
</div>
<ng-container *ngIf="currentStep === 1">
  <div mat-dialog-content class="content">
    <div *ngIf="isMetricsComplete$ | async" class="metrics-container">
      <table mat-table [dataSource]="metrics$" class="metrics-table">
        <ng-container matColumnDef="metric">
          <th class="metric-header" mat-header-cell *matHeaderCellDef>Metric</th>
          <td class="metric-cell" mat-cell *matCellDef="let element">
            <capra-icon class="metric-icon" icon="icon-metrics"></capra-icon> {{ element.label }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th class="description-header" mat-header-cell *matHeaderCellDef>Description</th>
          <td class="description-cell" mat-cell *matCellDef="let element">{{ element.desc }}</td>
        </ng-container>
        <ng-container matColumnDef="fields">
          <th class="fields-header" mat-header-cell *matHeaderCellDef>Available fields</th>
          <td class="fields-cell" mat-cell *matCellDef="let element">{{ element.dimensions.join(', ') }}</td>
        </ng-container>
        <ng-container matColumnDef="connection">
          <th class="connection-header" mat-header-cell *matHeaderCellDef>Connection</th>
          <td class="connection-cell" mat-cell *matCellDef="let element">
            <capra-icon class="icon-database" icon="icon-database"></capra-icon> {{ element.dataSourceName }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let entry"
          [ngClass]="{ selected: selectedMetric?.label === entry.label }"
          (click)="onRowClicked(row)"
        ></tr>
      </table>
      <div *ngIf="metricsError$ | async" class="metrics-load-error">
        There was a problem loading Metrics for this Datasource
      </div>
      <div *ngIf="(metrics$ | async)?.length === 0" class="metrics-load-error">No Metrics found</div>
    </div>
  </div>
  <div mat-dialog-actions class="actions">
    <div class="viz-buttons-wrapper">
      <div class="viz-buttons actions step1">
        <capra-button
          class="action cancel"
          text="Cancel"
          variant="secondary"
          color="neutral"
          (clicked)="onCancel()"
        ></capra-button>
        <capra-button
          class="action confirm"
          text="Use metric"
          [disabled]="!selectedMetric"
          (clicked)="onConfirm()"
        ></capra-button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="currentStep === 2">
  <div mat-dialog-content class="content tiles-container">
    <div class="tiles">
      <div
        class="tile-wrapper"
        [class.selected]="selectedVisualization === 'table'"
        (click)="onSelectVisualization('table')"
      >
        <div class="tile">
          <capra-icon class="tile-icon" icon="illo-metric-table-white"></capra-icon>
          <div class="tile-title">Table</div>
          <div class="tile-description">Show me a table of all fields</div>
        </div>
      </div>
      <div
        class="tile-wrapper"
        [class.selected]="selectedVisualization === 'line'"
        (click)="onSelectVisualization('line')"
      >
        <div class="tile">
          <capra-icon class="tile-icon" icon="illo-metric-line"></capra-icon>
          <div class="tile-title">Line</div>
          <div class="tile-description">Show me the metric over time</div>
        </div>
      </div>
      <div
        class="tile-wrapper"
        [class.selected]="selectedVisualization === 'bar'"
        (click)="onSelectVisualization('bar')"
      >
        <div class="tile">
          <capra-icon class="tile-icon" icon="illo-metric-bar"></capra-icon>
          <div class="tile-title">Bar</div>
          <div class="tile-description">Show me the metric over time</div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="actions">
    <div class="viz-buttons-wrapper">
      <div class="viz-buttons back">
        <capra-button
          class="action cancel"
          text="Back"
          variant="secondary"
          color="neutral"
          icon="icon-caret-left"
          (clicked)="previousStep()"
        ></capra-button>
      </div>
      <div class="viz-buttons actions step2">
        <capra-button
          class="action cancel"
          text="Cancel"
          variant="secondary"
          color="neutral"
          (clicked)="onCancel()"
        ></capra-button>
        <capra-button
          class="action confirm"
          text="Visualize"
          [disabled]="!selectedVisualization"
          (clicked)="gotoVisualization()"
        ></capra-button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="currentStep === 3">
  <div mat-dialog-content class="content">
    <div class="visualize-loading">
      <div class="loading-icon">
        <capra-icon class="icon" icon="illo-metric-loading"></capra-icon>
        <div class="status-icon">
          <capra-icon icon="illo-generating-export" class="spin"></capra-icon>
        </div>
      </div>

      <div class="title">Visualizing your Metric...</div>
      <p>The chart will display as soon as the data finishes running</p>
    </div>
  </div>
</ng-container>
